import * as React from 'react';
export const useUniqueId = () => {
  return React.useRef(Math.floor(Math.random() * 1e3).toString(16)).current;
};
